export default {
  currentPage(state, value) {
    return (state.currentPage = value);
  },

  perPage(state, value) {
    return (state.perPage = value);
  },

  loanTypesTotal(state, value) {
    return (state.loanTypesTotal = value);
  },

  loanTypes(state, value) {
    return (state.loanTypes = value);
  },

  searchQuery(state, value) {
    return (state.searchQuery = value);
  },

  tableLoading(state, value) {
    return (state.tableLoading = value);
  },

  loanCaps(state, value) {
    return (state.loanCaps = value);
  },
  loanCapsTotal(state, value) {
    return (state.loanCapsTotal = value);
  },
  loanCapsPerPage(state, value) {
    return (state.loanCapsPerPage = value);
  },
  loanCapsCurrentPage(state, value) {
    return (state.loanCapsCurrentPage = value);
  },
  modelType(state, value) {
    return (state.modelType = value);
  },
  loanApprovalsCurrentPage(state, value) {
    return (state.loanApprovalsCurrentPage = value);
  },
  loanApprovalsPerPage(state, value) {
    return (state.loanApprovalsPerPage = value);
  },
  loanApprovals(state, value) {
    return (state.loanApprovals = value);
  },
  loanApprovalsTotal(state, value) {
    return (state.loanApprovalsTotal = value);
  },
  loanRequestsTotal(state, value) {
    return (state.loanRequestsTotal = value);
  },
  loanRequests(state, value) {
    return (state.loanRequests = value);
  },
  loanRequestsCurrentPage(state, value) {
    return (state.loanRequestsCurrentPage = value);
  },
  loanRequestsPerPage(state, value) {
    return (state.loanRequestsPerPage = value);
  },
  loanRequestsApprovalTotal(state, value) {
    return (state.loanRequestsApprovalTotal = value);
  },
  loanRequestsApproval(state, value) {
    return (state.loanRequestsApproval = value);
  },
  loanRequestsApprovalCurrentPage(state, value) {
    return (state.loanRequestsApprovalCurrentPage = value);
  },
  loanRequestsApprovalPerPage(state, value) {
    return (state.loanRequestsApprovalPerPage = value);
  },
  loanDisbursementsTotal(state, value) {
    return (state.loanDisbursementsTotal = value);
  },
  loanDisbursements(state, value) {
    return (state.loanDisbursements = value);
  },
  loanDisbursementsCurrentPage(state, value) {
    return (state.loanDisbursementsCurrentPage = value);
  },
  loanDisbursementsPerPage(state, value) {
    return (state.loanDisbursementsPerPage = value);
  },
  loanRefundsTotal(state, value) {
    return (state.loanRefundsTotal = value);
  },
  loanRefunds(state, value) {
    return (state.loanRefunds = value);
  },
  loanRefundsCurrentPage(state, value) {
    return (state.loanRefundsCurrentPage = value);
  },
  loanRefundsPerPage(state, value) {
    return (state.loanRefundsPerPage = value);
  },
};
